exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader--loaderWidget[data-v-1bc94e55]{position:absolute;top:0;left:0;width:100%;height:100%}.loader-adminpanel .contain-pulse .square[data-v-1bc94e55]{display:block}", ""]);

// exports
